import { cn } from '@pray/shared/utils/styles';

type StreamingMessageProps = {
  response: string;
  styles: Record<string, string>;
};

export function StreamingMessage({ response, styles }: StreamingMessageProps) {
  return (
    <div className={cn(styles.message, styles.assistantMessage, styles.streaming)}>
      <div className={styles.messageHeader}>
        <span className={styles.role}>$ solomon</span>
      </div>
      <div className={styles.messageContent}>
        {response}
        <span className={styles.cursor}>|</span>
      </div>
    </div>
  );
}
